export const INLINE_EDITOR_HERO_SECTION_TITLE = "HERO_MAIN";

export type PublicEditorArticle = {
  id: string;
  title: string;
  slug: string;
  coverImage: string;
  status: "DRAFT" | "PUBLISHED";
  categoryName: string;
  categorySlug: string;
  leagueSlugs: string[];
  publishedAt: string | null;
};

export type PublicEditorSection = {
  id: string;
  title: string;
  subtitle: string | null;
  layout: string;
  order: number;
  articleIds: string[];
};
